import { useMemo, useState } from "react";

import Modal from "@components/Modal";
import Alert from "@components/Alert";
import StoresFilters from "@components/ProductPage/ProductStoreAvailability/StoresFilters";
import StoresList from "@components/ProductPage/ProductStoreAvailability/StoresList";
import AvailableStoresModalStoreCard from "@components/ProductPage/ProductStoreAvailability/AvailableStoresModal/AvailableStoresModalStoreCard";
import sortedStores from "@lib/sortedStores";
import filterStores from "@lib/filterStores";

const AvailableStoresModal = ({ product, onStoreSelect, selectedStore }) => {
  const [regionIdFilter, setRegionIdFilter] = useState();
  const [storeNameFilter, setStoreNameFilter] = useState("");

  const storesData = useMemo(
    () =>
      sortedStores({
        storesData: product?.stockInfo,
        stickyStore: selectedStore,
      }),
    [product, selectedStore]
  );

  // Get available regions form product stores
  const regions = useMemo(
    () =>
      storesData
        .reduce((acc, store) => {
          if (!acc.find((region) => region.id === store.region_id)) {
            acc.push({
              id: store.region_id,
              name: store.region_name,
            });
          }

          return acc;
        }, [])
        .sort((a, b) => a.name.localeCompare(b.name)),
    [product]
  );

  const handleFiltersChange = ({ regionId, storeSearch }) => {
    if (regionId !== regionIdFilter) {
      setRegionIdFilter(regionId);
    }

    if (storeSearch && storeSearch.length > 2) {
      setStoreNameFilter(storeSearch);
    } else if (!storeSearch || storeSearch.length <= 2) {
      setStoreNameFilter("");
    }
  };

  const filteredStores = filterStores({
    storesData,
    regionId: regionIdFilter,
    storeName: storeNameFilter,
  });

  const hasStores = filteredStores.length > 0;

  return (
    <Modal
      header={
        <div className="text-[18px]">
          Produsul este disponibil doar in magazinele de mai jos
        </div>
      }
      id="AvailableStoresModal"
    >
      <div className="mb-[20px]">
        <Alert type="info" showIcon>
          Pentru a rezerva acest produs, trebuie sa il adaugi in cos. Poti
          continua de acolo procesul de rezervare.
        </Alert>
      </div>

      <StoresFilters regions={regions} onFiltersChange={handleFiltersChange} />

      {hasStores ? (
        <StoresList storesData={filteredStores}>
          <AvailableStoresModalStoreCard
            onStoreSelect={onStoreSelect}
            selectedStoreId={selectedStore?.id}
            product={product}
          />
        </StoresList>
      ) : (
        <div className="mt-[20px]">
          <Alert type="error" showIcon>
            Nu am gasit un magazin care sa indeplineasca criteriile filtrelor
            selectate.
          </Alert>
        </div>
      )}
    </Modal>
  );
};

export default AvailableStoresModal;
